import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AppConfigsService } from '@core/app-configs/services/app-configs.service';
import { HealthService } from '@core/monitoring/services/health.service';
import { NavController } from '@ionic/angular/standalone';
import { map, of, take } from 'rxjs';

export const serviceUnavailableGuard: CanActivateFn = () => {
    const healthService: HealthService = inject(HealthService);
    const navController: NavController = inject(NavController);
    const appConfigsService = inject(AppConfigsService);

    if (!!appConfigsService.appConfigs().maintenances?.app?.in_maintenance || healthService.healthy() === false) {
        return of(true);
    }

    if (healthService.healthy() === true) {
        void navController.navigateRoot('/dashboard', { replaceUrl: true });
        return of(false);
    }

    return healthService.checkApiServerStatus().pipe(
        take(1),
        map((ok) => {
            if (!ok) return true;
            void navController.navigateRoot('/dashboard', { replaceUrl: true });
            return false;
        })
    );
};
